export default (urlParams) => {
  const paramsString = Array.from(urlParams.entries()).length > 0 ? `?${urlParams.toString()}` : ''
  if (paramsString) {
    window.history.replaceState({}, '', paramsString)
  }
}
